import React from "react";

type SolventType = {
  solvent?: string;
};

type MeasureType = {
  measure?: string;
};

type ConcType = {
  conc?: number;
};

type UnitType = {
  unit?: string;
};

type SaltType = {
  salt?: string;
};

type CommentType = {
  comment?: string;
};

type Item = SolventType | MeasureType | ConcType | UnitType | SaltType | CommentType;

interface ITableRow {
  data?: Item[];
}

const TableRow: React.FC<ITableRow> = ({ data }) => {
  return (
    <div className="table-solubilities__tr flex flex-ai-center flex-jc-between">
      {data?.map((item, i) => {
        if (
          ("solvent" in item) ||
          ("measure" in item && item.measure) ||
          ("conc" in item) ||
          ("unit" in item) ||
          ("comment" in item)
        ) {
          return (
            <div key={`table-row-${i}`} className="table-solubilities__td">
              {"solvent" in item && <div className="table-solubilities__text">{item.solvent}</div>}
              {"measure" in item && <div className="table-solubilities__text">{item.measure}</div>}
              {"conc" in item && <div className="table-solubilities__text">{item.conc}</div>}
              {"unit" in item && <div className="table-solubilities__text">{item.unit}</div>}
              {"comment" in item && <div className="table-solubilities__text">{item.comment}</div>}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default TableRow;